import React from 'react';
import PropTypes from 'prop-types';

export const marks = Object.freeze({
  GOOD: 'good',
  IMPORTANT: 'important',
  INFO: 'info',
  URGENT: 'urgent'
});

function MarkedMessage(props) {
  const { children, mark } = props;

  return (
    <div className={`messageContainer mark ${mark} marginBelow`}>
      <div className='message'>
        { children }
      </div>
    </div>
  );
}

MarkedMessage.propTypes = {
  children: PropTypes.node,
  mark: PropTypes.oneOf(Object.values(marks))
};

export default MarkedMessage;
